import '.c0{flex-shrink:0;}.ssr-plugin'
import '.c1{padding:1rem;}.ssr-plugin'
import '.z{width:100%;}.ssr-plugin'
import '.bp{height:100%;}.ssr-plugin'
import '.bb{border:none;}.ssr-plugin'
import '.bc{background-color:transparent;}.ssr-plugin'
import '.fd{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.dr{position:sticky;}.ssr-plugin'
import '.fe{top:4rem;}.ssr-plugin'
import '.ff{z-index:7;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.fg{padding-bottom:1rem;}.ssr-plugin'
import '.v{margin-bottom:1rem;}.ssr-plugin'
import '.fh{border-bottom:var(--blue-border);}.ssr-plugin'
import '.a4{position:fixed;}.ssr-plugin'
import '.cp{top:0;}.ssr-plugin'
import '.bt{left:0px;}.ssr-plugin'
import '.bu{right:0px;}.ssr-plugin'
import '.fi{bottom:0px;}.ssr-plugin'
import '.f1{z-index:9999;}.ssr-plugin'
import '.fj{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.df{justify-content:flex-end;}.ssr-plugin'
import '.c2{flex:1;}.ssr-plugin'
import '.aj{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="c0 c1 z bp bb bc fd"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a b ab"
    >
      <div className="dr fe ff ae fg v fh a"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="a4 cp bt bu fi f1 ae fj a b"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="c1 a df fh"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="c2 aj">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
